module.exports = __webpack_public_path__ + "3d3bfa5d618585204b42d828b13730ff.pdf";